export const SMALL_MARGIN = '18px'
export const LARGE_MARGIN = '30px'
